module.exports = {"450803001":"江南","450803100":"桥圩镇","450803101":"木格镇","450803102":"木梓镇","450803103":"湛江镇","450803104":"东津镇","450803105":"八塘镇","450803106":"新塘镇","450803107":"瓦塘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450803.json
// module id = 1955
// module chunks = 0